import createCrud from './crud';
import { http } from 'utils'

import { SET_SINGLE, UPDATE_LIST_ITEM } from 'vx/mutations'

export default createCrud({
    resource: 'sign-requests',
    actions: {
      async approve({ getters, commit, state }) {
        const response = await http.post(getters.uri(`${state.single.id}/approve`))

        if (response.data.hasOwnProperty('data')) {
          commit(SET_SINGLE, response.data.data)
          //Also add this item to the list
          commit(UPDATE_LIST_ITEM, [response.data.data])
        } else {
          commit(SET_SINGLE, response.data)
          //Also add this item to the list
          commit(UPDATE_LIST_ITEM, [response.data])
        }

        return response
      },

      async unapprove({ getters, commit, state }) {
        const response = await http.post(getters.uri(`${state.single.id}/unapprove`))

        if (response.data.hasOwnProperty('data')) {
          commit(SET_SINGLE, response.data.data)
          //Also add this item to the list
          commit(UPDATE_LIST_ITEM, [response.data.data])
        } else {
          commit(SET_SINGLE, response.data)
          //Also add this item to the list
          commit(UPDATE_LIST_ITEM, [response.data])
        }

        return response
      },
    }
  });
